/**
 * Утиліти для роботи з URL
 */

/**
 * Оновлює URL без перезавантаження сторінки
 */
export function updateURLWithoutReload(url: string) {
  window.history.pushState({}, "", url);
}

/**
 * Створює URL з query параметрами для пагінації
 */
export function createPaginationURL(
  page: number,
  sortBy: string | null = null,
  existingSearch: string = "",
  pageSize: number | null = null
): string {
  // Зберігаємо інші query параметри (на майбутнє: фільтри/пошук тощо),
  // але контрольовано оновлюємо page/sort.
  const params = new URLSearchParams(existingSearch);
  params.set("page", page.toString());
  if (sortBy) {
    params.set("sort", sortBy);
  } else {
    params.delete("sort");
  }
  if (pageSize) {
    params.set("pageSize", pageSize.toString());
  } else {
    params.delete("pageSize");
  }
  return `?${params.toString()}`;
}
